// extracted by mini-css-extract-plugin
module.exports = {"root":"SplashScreen_root__EKd_P","logo":"SplashScreen_logo__VBPct","fadeIn":"SplashScreen_fadeIn__kV5eS"};